import React from 'react';
import styled from 'styled-components';
import {Icon} from '../../Icon/Icon';
import {Btn} from './Btn';

const CloseBtn = styled(Btn)`
    ${Icon.Wrapper} svg {
        height: 20px;
        width: 20px;
    }
`;

/**
 * @description
 *
 * This is a button component designed to display a close icon in gray color. When hovered over, it changes to red. This component is intended to be used within an `Aside` component as the close button for `Aside` modal components.
 * To use this, you should apply the component <ModalCloseBtn onClick={onClose} /> inside the component <AsideSlideIn.Header>. If you are including a title in this header, make sure to place the button on the right side. You can view the example below to see how to do this."
 *
 * @param {object} param0
 *
 * @param {Function} [param0.onClick]
 * Callback function triggered when the button is clicked.
 *
 * @example
 *  ```jsx
 *
 *  <Aside.Header>
 *      Header title
 *      <ModalCloseBtn onClick={onClose} />
 *  </Aside.Header>
 * ```
 */
export const ModalCloseBtn = ({onClick}) => (
    <CloseBtn link subtle color="danger" onClick={onClick}>
        <Icon name="clear" />
    </CloseBtn>
);
